const pirfix = 'SPOT_FE_PREMARKET_';

export const ConstantCacheKeys = {

  /**
   * spot/api/marketTrading/v1/order/tradeOrders
   */
  // TRADE_ORDERS: pirfix + 'TRADE_ORDERS',

  /**
   * /spot/api/marketTrading/v2/token/tokenList
   */
  TOKEN_LIST: pirfix + 'TOKEN_LIST',

  /**
   * /spot/api/marketTrading/v2/token/tokenInfo
   */
  TOKEN_INFO: pirfix + 'TOKEN_INFO',

  /**
   * spot/api/marketTrading/v2/token/dynamicsData
   */
  // TOKEN_DYNAMICS_DATA: pirfix + 'TOKEN_DYNAMICS_DATA',
};
